export const MAX_SAFE_GQL_INTEGER = 2_147_483_647
export const DEFAULT_REFETCH_INTERVAL: number = 5_000 // [ms]
